import { c as _c } from "react/compiler-runtime";
import { makeStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
const useStyles = makeStyles(/* istanbul ignore next */({
  palette
}) => ({
  root: {
    color: palette.brand.main
  }
}));
const MoreIconButton = t0 => {
  const $ = _c(10);
  let ariaLabel;
  let otherProps;
  if ($[0] !== t0) {
    ({
      ariaLabel,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = otherProps;
  } else {
    ariaLabel = $[1];
    otherProps = $[2];
  }
  const classes = useStyles();
  let t1;
  if ($[3] !== classes.root) {
    t1 = {
      root: classes.root
    };
    $[3] = classes.root;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MoreVertIcon />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== ariaLabel || $[7] !== otherProps || $[8] !== t1) {
    t3 = <IconButton classes={t1} size="large" aria-label={ariaLabel} {...otherProps}>{t2}</IconButton>;
    $[6] = ariaLabel;
    $[7] = otherProps;
    $[8] = t1;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default MoreIconButton;